var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3409_3529)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.094 8.33834L24.719 0.70925C24.2587 0.518188 23.7413 0.518094 23.281 0.70925L4.90603 8.33834C4.20619 8.62897 3.75 9.31222 3.75 10.07V19.3442C3.75 32.1142 11.4683 43.6011 23.2914 48.4269C23.7456 48.6122 24.2543 48.6122 24.7086 48.4269C36.5315 43.6012 44.25 32.1143 44.25 19.3442V10.07C44.25 9.31222 43.7939 8.62897 43.094 8.33834ZM21.5936 26.163L30.9502 16.346C31.8003 15.4541 33.1786 15.454 34.0288 16.346C34.8789 17.238 34.8788 18.6841 34.0287 19.576L23.1329 31.008C22.2826 31.9002 20.9043 31.8998 20.0543 31.008L13.9706 24.6249C13.1205 23.7329 13.1205 22.2868 13.9706 21.3949C14.8208 20.503 16.1991 20.5029 17.0492 21.3949L21.5936 26.163Z",
    fill: "#6B7CFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3409_3529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.565918)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/Icon 1.99b987f4bca360a8f3d702f1f95b8947.svg";
export { ForwardRef as ReactComponent };